import request from 'api/drivers/socket';

export default function fetchThreadIndex() {
  return request({ url: '/chat/threads' });
}
